export default __webpack_public_path__ + "static/media/alert.95768bbd.svg";